import '../App.css';
import React, { useEffect } from "react";
import Nav from '../components/Nav.js';
import Footer from '../components/Footer.js';

const Privacy = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Nav minimal />
      <main className="privacy-page">
        <span className="eyebrow"><span className="dot" /> Legal</span>

          <h1>Privacy Policy</h1>
          <p><strong>Last Updated: 12 March, 2025</strong></p>
          <p><strong>Meck Interactives</strong> ("we," "our," or "us") is committed to protecting your privacy. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you play our games.</p>
          <p>By downloading and using the games, you consent to the practices described in this Privacy Policy. If you do not agree, please do not play our games.</p>
          
          <h2>1. Information We Collect</h2>
          <ol>
              <li><strong>Personal Information</strong>
                  <ul>
                      <li>Contact information (e.g., email address) when you interact with customer support.</li>
                      <li>Information you provide when participating in in-game events, surveys, or promotions.</li>
                  </ul>
              </li>
              <li><strong>Non-Personal Information</strong>
                  <ul>
                      <li>Device information (e.g., device model, operating system, unique device identifiers).</li>
                      <li>Game usage data (e.g., gameplay statistics, interactions, preferences).</li>
                      <li>Crash reports and performance data.</li>
                  </ul>
              </li>
              <li><strong>Information from Third-Party Services</strong>
                  <ul>
                      <li>If you log in or interact with third-party services (e.g., Google Play Games, Apple Game Center, social media), we may receive certain data from those services according to their privacy policies and your permissions.</li>
                  </ul>
              </li>
          </ol>
          
          <h2>2. How We Use Your Information</h2>
          <ol>
            <ul>
              <li>To provide, maintain, and improve the Game.</li>
              <li>To personalize user experience and enhance gameplay.</li>
              <li>To process transactions and in-app purchases.</li>
              <li>To provide customer support and respond to inquiries.</li>
              <li>To monitor and analyze game performance, usage, and trends.</li>
              <li>To comply with legal requirements and protect our rights.</li>
            </ul>
          </ol>
          
          <h2>3. Sharing Your Information</h2>
          <p>We do not sell or rent your personal information. However, we may share information in the following cases:</p>
          <ol>
              <li><strong>With Service Providers:</strong> Third-party companies that help operate and maintain the Game (e.g., analytics providers, payment processors).</li>
              <li><strong>Legal Compliance:</strong> When required by law, legal processes, or to protect our rights and users.</li>
              <li><strong>Business Transfers:</strong> If we undergo a merger, acquisition, or asset sale, your data may be transferred.</li>
          </ol>
          
          <h2>4. Third-Party Services</h2>
          <p>Our games may contain links to third-party services (e.g., ads, social media, external websites). We are not responsible for their privacy practices. Please review their privacy policies before engaging with them.</p>
          
          <h2>5. Data Security</h2>
          <p>We implement reasonable security measures to protect your information. However, no method of transmission over the internet or electronic storage is 100% secure. Play our games at your own risk.</p>
          
          <h2>6. Your Rights and Choices</h2>
          <p>Depending on your location, you may have the following rights:</p>
          <ol>
              <li><strong>Access & Correction:</strong> Request access to or correction of your data.</li>
              <li><strong>Deletion:</strong> Request deletion of your personal data.</li>
              <li><strong>Opt-Out:</strong> Disable data collection for analytics and advertising.</li>
          </ol>
          <p>You can exercise these rights by contacting us at 
             <a href="mailto:app@meck-int.com">app@meck-int.com</a>.</p>
          
          <h2>7. Children's Privacy</h2>
          <p>We do not knowingly collect personal data from children. If you believe we have collected such data, please contact us to remove it.</p>
          
          <h2>8. Changes to This Privacy Policy</h2>
          <p>We may update this Privacy Policy from time to time. We will notify you of significant changes by updating the "Last Updated" date. Your continued use of our services and games constitutes acceptance of the updated policy.</p>
          
          <h2>9. Contact Us</h2>
          <p>If you have any questions about this Privacy Policy, please contact us at 
             <a href="mailto:app@meck-int.com">app@meck-int.com</a>.</p>
          <p>Meck Interactive</p>
      </main>
      <Footer />
    </>
  );
};

export default Privacy;